import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';
import { AUTOCALLER_URL } from '@shared/helpers/env';

class ProductsServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }

  getList(params) {
    return this.http.get('', { params });
  }
  getProducts() {
    return this.http.get('select');
  }

  createItem(params) {
    return this.http.post('', params);
  }

  editProduct(id, params) {
    return this.http.put(`${id}`, params);
  }

  deleteProduct(id) {
    return this.http.delete(`${id}`);
  }
}

export const ProductsService = new ProductsServiceClass({
  api_version: 1,
  base_url: AUTOCALLER_URL,
  resource: 'products'
});
